import request from "@/utils/request";

// 获取微信票据_appId
export function getJsTicket(params) {
  return request({
    url: "/wx/openapi/getJsTicket",
    method: "get",
    params
  });
}


// 获取用户信息
export function getUserInfo(params) {
  return request({
    url: "/wx/openapi/getUserInfo",
    method: "get",
    params
  });
}


// 根据编号，获取学校信息
export function detailBySchoolNo(params) {
  return request({
    url: "/biz/schoolInfo/detailBySchoolNo/openapi",
    method: "get",
    params
  });
}


// 根据学校名称，获取学校列表
export function listBySchoolName(params) {
  return request({
    url: "/biz/schoolInfo/listBySchoolName/openapi",
    method: "get",
    params
  });
}


// 获取班级信息
export function listBySchoolNo(params) {
  return request({
    url: "/biz/schoolClasses/listBySchoolNo/openapi",
    method: "get",
    params
  });
}

// 刷卡
export function doCard(params) {
  return request({
    url: "/biz/schoolCardRecord/doCard/openapi",
    method: "get",
    params
  });
}


// 微信绑定学校
export function schoolwechatbind(data) {
  return request({
    url: "/biz/schoolwechatbind/bind/openapi",
    method: "post",
    data
  });
}



// 微信解绑学校列表
export function schoolwechatbindList(params) {
  return request({
    url: "/biz/schoolwechatbind/list/openapi",
    method: "get",
    params
  });
}

// 微信解绑学校
export function schoolwechatUnbind(data) {
  return request({
    url: "/biz/schoolwechatbind/unbind/openapi",
    method: "post",
    data
  });
}


// 在线放学
export function onlineLetOut(data) {
  return request({
    url: "/biz/schoolClasses/onlineLetOut/openapi",
    method: "post",
    data
  });
}